import React from 'react';
import solimatLogo from '../../../img/solimat-logo.svg';
import './MovilAppNew.scss';

const MovilAppNew: React.FC = () => {
  return (
    <section className="appdl">
      <div className="container">
        <div className="appdl__card reveal is-in">
          <div className="appdl__phone-side">
            <div className="appdl__phone" aria-hidden>
              <div className="appdl__phone-frame">
                <div className="appdl__phone-notch"></div>
                <div className="appdl__phone-screen">
                  <img src={solimatLogo} alt="" className="appdl__phone-logo" />
                  <div className="appdl__phone-field"></div>
                  <div className="appdl__phone-field"></div>
                  <div className="appdl__phone-row">
                    <span className="appdl__phone-link">Olvidé contraseña</span>
                    <span className="appdl__phone-btn">Entrar</span>
                  </div>
                  <svg className="appdl__phone-curve" viewBox="0 0 200 200" aria-hidden>
                    <path d="M-20 200 C 40 140, 120 140, 220 200 L 220 220 L -20 220 Z" fill="#E6F1F8" opacity="0.6" />
                  </svg>
                </div>
                <div className="appdl__phone-home"></div>
              </div>
            </div>
          </div>
          <div className="appdl__body">
            <span className="eyebrow eyebrow--accent">Solimat App</span>
            <h2 className="appdl__title">Descarga Solimat App</h2>
            <p className="appdl__lede">
              <strong>SOLIMAT</strong> pone a disposición de los usuarios del
              Portal de Paciente las aplicaciones para móviles <strong>iOS</strong> y
              <strong> Android</strong>. Gestiona tus prestaciones desde cualquier
              lugar, recibe notificaciones de tus citas y consulta tu expediente
              médico al instante.
            </p>
            <div className="appdl__stores">
              <a href="https://play.google.com/store/apps/details?id=com.solimat.paciente" target="_blank" rel="noopener noreferrer" className="appstore" aria-label="Disponible en Google Play">
                <svg width="26" height="28" viewBox="0 0 24 26" aria-hidden>
                  <path d="M3.4 1.6c-.3.3-.4.7-.4 1.3v20.2c0 .6.1 1 .4 1.3l11-10.4L3.4 1.6z" fill="#34A853" />
                  <path d="M17.2 9.2 14 12l3.2 3-3.2 3 3.2-3 4.8-2.8c1.3-.7 1.3-2.6 0-3.3l-4.8-2.7z" fill="#FBBC04" />
                  <path d="M3.4 1.6 14 12 3.4 24.4c.3.3.8.3 1.4 0L18 17l-4-5 4-5L4.8 1.6c-.6-.3-1.1-.3-1.4 0z" fill="#EA4335" />
                  <path d="M3.4 1.6 14 12 3 23.4c-.1-.3-.1-.6 0-.9V2.5c-.1-.3-.1-.6.4-.9z" fill="#4285F4" />
                </svg>
                <span className="appstore__txt">
                  <small>DISPONIBLE EN</small>
                  <strong>Google Play</strong>
                </span>
              </a>
              <a href="https://apps.apple.com/es/app/portal-paciente-solimat/id6745520018" target="_blank" rel="noopener noreferrer" className="appstore" aria-label="Consíguelo en el App Store">
                <svg width="24" height="28" viewBox="0 0 24 28" fill="#fff" aria-hidden>
                  <path d="M17.5 14.7c0-3.3 2.7-4.9 2.8-5-1.5-2.2-3.9-2.5-4.7-2.5-2-.2-3.9 1.2-4.9 1.2-1 0-2.6-1.2-4.3-1.1C4.3 7.3 2.2 8.6 1 10.7c-2.2 3.8-.5 9.4 1.6 12.5 1 1.5 2.3 3.2 3.9 3.1 1.6-.1 2.2-1 4-1 1.9 0 2.4 1 4 1 1.7 0 2.7-1.5 3.8-3 .9-1.2 1.4-2.4 1.8-3.7-2-.7-3.6-2.6-3.6-4.9zM14.4 5.1c.9-1.1 1.5-2.5 1.3-4-1.3 0-2.8.8-3.7 1.9-.8 1-1.6 2.5-1.4 3.9 1.5.1 2.9-.7 3.8-1.8z" />
                </svg>
                <span className="appstore__txt">
                  <small>CONSÍGUELO EN EL</small>
                  <strong>App Store</strong>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MovilAppNew;
